/**
 * Introduction
 * The RevSpring REST API provides a powerful and easy way to integrate RevSpring functionality into your own applications.You can browse through the supported operations in the Resources and Operations section below. You can even invoke the operations directly from this page using the corresponding \"Try this\" operation functionality!  Before using the RevSpring API, you will need to contact your RevSpring Account Representative. If you are new to RevSpring, please complete the following form to get the contract process started: [Contact Us Form](http://revspringinc.com/contact-us/) ## Getting started:   1. Obtain a unique set of credentials (a client_id, a client_secret) for use in your application by contacting  your RevSpring Account Manager. The client_id and the client_secret are required in order to generate an Access  Token. The RevSpring Account Manager will also be providing the clientId and clientType as these values are  required in all API calls other than the Auth operations.    2. All of the API calls require an Auth Access Token. Use the credentials provided in step 1 to generate an Auth  Access Token using the following method: /api/rest/auth/oauth/token.     3. Use the access_token returned to call any of the available REST API Operations. When calling other operations,  you will need to use the clientId and clientIdType in the Header along with the access_token.    4. The Try this operation button is available within each operation for testing.    ## Using the \"Try this\" operation functionality:  To use the \"Try this\" operation functionality applicable to each operation,  first provide valid values for each parameter under the \"Parameter\" column. To easily populate complex parameter values, select Model Schema under the \"Data Type\" column and then click on the JSON text that is revealed. You can then edit the populated \"Value\" field as needed, and click the corresponding \"Try this\" operation button to watch the API operation in action.    ## Try Postman :  Open the links and save to download the files. <a href = \"/apidoc/v1/api/postman/EM3_collection.json\"><strong>Postman Collection</strong></a>  <a href = \"/apidoc/v1/api/postman/EM3_environment.json\"><strong>Postman Variables</strong></a>  <br>   ## Error Codes :  Error codes which may appear when working with the API.  <a href = \"/apidoc/v1/api/errorcodes/codes.html\"><strong>Error Codes</strong></a>  <br> <br> © 2019 RevSpring. All Rights Reserved.  [Terms](http://revspringinc.com/terms-conditions/)   [Privacy](http://revspringinc.com/privacy-policy/) ## Resources and Operations
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AccessTokenError } from '../model/accessTokenError';
import { AdminInfo4 } from '../model/adminInfo4';
import { CreateRequest } from '../model/createRequest';
import { CreateRequest2 } from '../model/createRequest2';
import { CreateResponse } from '../model/createResponse';
import { CreateResponse2 } from '../model/createResponse2';
import { DecodeTrackRequest } from '../model/decodeTrackRequest';
import { DecodeTrackResponse } from '../model/decodeTrackResponse';
import { DecryptTrackRequest } from '../model/decryptTrackRequest';
import { DecryptTrackResponse } from '../model/decryptTrackResponse';
import { DeviceRequest } from '../model/deviceRequest';
import { DeviceResponse } from '../model/deviceResponse';
import { ErrorMessage } from '../model/errorMessage';
import { GatewayResponseInfo } from '../model/gatewayResponseInfo';
import { NetworkDevicePingRequest2 } from '../model/networkDevicePingRequest2';
import { NetworkDevicePingResponse2 } from '../model/networkDevicePingResponse2';
import { NetworkDeviceProcessTransactionRequest } from '../model/networkDeviceProcessTransactionRequest';
import { NetworkDeviceProcessTransactionResponse } from '../model/networkDeviceProcessTransactionResponse';
import { StdDeviceRequest } from '../model/stdDeviceRequest';
import { StdDeviceResponse } from '../model/stdDeviceResponse';
import { VaultCreateRequest } from '../model/vaultCreateRequest';
import { VaultCreateResponse } from '../model/vaultCreateResponse';
import { VaultRetrieveResponse } from '../model/vaultRetrieveResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PmtProcService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * PmtProc_AdminInfo, Get the Admin Info
     * Gives the latest Version Control and Host Info
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtProcV1AdminInfoGet(observe?: 'body', reportProgress?: boolean): Observable<AdminInfo4>;
    public pmtProcV1AdminInfoGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminInfo4>>;
    public pmtProcV1AdminInfoGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminInfo4>>;
    public pmtProcV1AdminInfoGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<AdminInfo4>(`${this.basePath}/PmtProc/V1/Admin/Info`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtProc_DeviceRequest, Create the device request
     * Create the device request
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtProcV1DeviceRequestPost(Request: StdDeviceRequest, observe?: 'body', reportProgress?: boolean): Observable<DeviceRequest>;
    public pmtProcV1DeviceRequestPost(Request: StdDeviceRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DeviceRequest>>;
    public pmtProcV1DeviceRequestPost(Request: StdDeviceRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DeviceRequest>>;
    public pmtProcV1DeviceRequestPost(Request: StdDeviceRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtProcV1DeviceRequestPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<DeviceRequest>(`${this.basePath}/PmtProc/V1/Device/Request`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtProc_DeviceResponse, Converting device response into standard response
     * Converting device response into standard response
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtProcV1DeviceResponsePost(Request: DeviceResponse, observe?: 'body', reportProgress?: boolean): Observable<StdDeviceResponse>;
    public pmtProcV1DeviceResponsePost(Request: DeviceResponse, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StdDeviceResponse>>;
    public pmtProcV1DeviceResponsePost(Request: DeviceResponse, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StdDeviceResponse>>;
    public pmtProcV1DeviceResponsePost(Request: DeviceResponse, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtProcV1DeviceResponsePost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<StdDeviceResponse>(`${this.basePath}/PmtProc/V1/Device/Response`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtProc_RetrieveGateways, Retrieve the gateways supported by each processor
     * Retrieve the gateways supported by each processor
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtProcV1GatewayGet(observe?: 'body', reportProgress?: boolean): Observable<GatewayResponseInfo>;
    public pmtProcV1GatewayGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GatewayResponseInfo>>;
    public pmtProcV1GatewayGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GatewayResponseInfo>>;
    public pmtProcV1GatewayGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GatewayResponseInfo>(`${this.basePath}/PmtProc/V1/Gateway`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtProc_GatewayTransactionProcess, Reporcess a Transaction from GatewayTransaction table
     * Reporcess a Transaction from GatewayTransaction table
     * @param Id Enter the Id
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtProcV1GatewayTransactionIdProcessPost(Id: number, Request: CreateRequest2, observe?: 'body', reportProgress?: boolean): Observable<CreateResponse2>;
    public pmtProcV1GatewayTransactionIdProcessPost(Id: number, Request: CreateRequest2, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CreateResponse2>>;
    public pmtProcV1GatewayTransactionIdProcessPost(Id: number, Request: CreateRequest2, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CreateResponse2>>;
    public pmtProcV1GatewayTransactionIdProcessPost(Id: number, Request: CreateRequest2, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling pmtProcV1GatewayTransactionIdProcessPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtProcV1GatewayTransactionIdProcessPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<CreateResponse2>(`${this.basePath}/PmtProc/V1/GatewayTransaction/${encodeURIComponent(String(Id))}/Process`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtProc_NetworkDevicePing, Ping a network device
     * Ping a network device
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtProcV1NetworkDevicePingPost(Request: NetworkDevicePingRequest2, observe?: 'body', reportProgress?: boolean): Observable<NetworkDevicePingResponse2>;
    public pmtProcV1NetworkDevicePingPost(Request: NetworkDevicePingRequest2, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NetworkDevicePingResponse2>>;
    public pmtProcV1NetworkDevicePingPost(Request: NetworkDevicePingRequest2, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NetworkDevicePingResponse2>>;
    public pmtProcV1NetworkDevicePingPost(Request: NetworkDevicePingRequest2, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtProcV1NetworkDevicePingPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<NetworkDevicePingResponse2>(`${this.basePath}/PmtProc/V1/Network/Device/Ping`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtProc_NetworkDeviceProcessTransaction, Process network device transaction
     * Process network device transaction
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtProcV1NetworkDeviceProcessTransactionPost(Request: NetworkDeviceProcessTransactionRequest, observe?: 'body', reportProgress?: boolean): Observable<NetworkDeviceProcessTransactionResponse>;
    public pmtProcV1NetworkDeviceProcessTransactionPost(Request: NetworkDeviceProcessTransactionRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NetworkDeviceProcessTransactionResponse>>;
    public pmtProcV1NetworkDeviceProcessTransactionPost(Request: NetworkDeviceProcessTransactionRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NetworkDeviceProcessTransactionResponse>>;
    public pmtProcV1NetworkDeviceProcessTransactionPost(Request: NetworkDeviceProcessTransactionRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtProcV1NetworkDeviceProcessTransactionPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<NetworkDeviceProcessTransactionResponse>(`${this.basePath}/PmtProc/V1/Network/Device/ProcessTransaction`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtProc_Payment, Make a payment
     * Make a payment
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtProcV1PmtProcPost(Request: CreateRequest, observe?: 'body', reportProgress?: boolean): Observable<CreateResponse>;
    public pmtProcV1PmtProcPost(Request: CreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CreateResponse>>;
    public pmtProcV1PmtProcPost(Request: CreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CreateResponse>>;
    public pmtProcV1PmtProcPost(Request: CreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtProcV1PmtProcPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<CreateResponse>(`${this.basePath}/PmtProc/V1/PmtProc`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtProc_DecryptTrack, Decrypt the track
     * Decrypt the Encrypted Track
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtProcV1TrackDecryptPost(Request: DecryptTrackRequest, observe?: 'body', reportProgress?: boolean): Observable<DecryptTrackResponse>;
    public pmtProcV1TrackDecryptPost(Request: DecryptTrackRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DecryptTrackResponse>>;
    public pmtProcV1TrackDecryptPost(Request: DecryptTrackRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DecryptTrackResponse>>;
    public pmtProcV1TrackDecryptPost(Request: DecryptTrackRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtProcV1TrackDecryptPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<DecryptTrackResponse>(`${this.basePath}/PmtProc/V1/Track/Decrypt`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtProc_DecodeTrack, Decode the track
     * Decode the track
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtProcV1TrackPost(Request: DecodeTrackRequest, observe?: 'body', reportProgress?: boolean): Observable<DecodeTrackResponse>;
    public pmtProcV1TrackPost(Request: DecodeTrackRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DecodeTrackResponse>>;
    public pmtProcV1TrackPost(Request: DecodeTrackRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DecodeTrackResponse>>;
    public pmtProcV1TrackPost(Request: DecodeTrackRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling pmtProcV1TrackPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<DecodeTrackResponse>(`${this.basePath}/PmtProc/V1/Track`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtProc_DeleteVault, Delete payment information from Vault
     * Delete payment information from Vault using tokenId
     * @param TokenId Enter the TokenId to delete information from vault
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtProcV1VaultDelete(TokenId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public pmtProcV1VaultDelete(TokenId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public pmtProcV1VaultDelete(TokenId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public pmtProcV1VaultDelete(TokenId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (TokenId === null || TokenId === undefined) {
            throw new Error('Required parameter TokenId was null or undefined when calling pmtProcV1VaultDelete.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (TokenId !== undefined) {
            queryParameters = queryParameters.set('TokenId', <any>TokenId);
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/PmtProc/V1/Vault`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtProc_RetrieveVault, Retrieve payment information from Vault
     * Retrieve payment information from Vault using id
     * @param TokenId Enter the TokenId to retrieve card information
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtProcV1VaultGet(TokenId: string, observe?: 'body', reportProgress?: boolean): Observable<VaultRetrieveResponse>;
    public pmtProcV1VaultGet(TokenId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VaultRetrieveResponse>>;
    public pmtProcV1VaultGet(TokenId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VaultRetrieveResponse>>;
    public pmtProcV1VaultGet(TokenId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (TokenId === null || TokenId === undefined) {
            throw new Error('Required parameter TokenId was null or undefined when calling pmtProcV1VaultGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (TokenId !== undefined) {
            queryParameters = queryParameters.set('TokenId', <any>TokenId);
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<VaultRetrieveResponse>(`${this.basePath}/PmtProc/V1/Vault`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtProc_CreateVault, Save payment information in the Vault
     * Save payment information in the Vault
     * @param vaultRequest Enter the payment information to be saved in vault.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtProcV1VaultPost(vaultRequest: VaultCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<VaultCreateResponse>;
    public pmtProcV1VaultPost(vaultRequest: VaultCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VaultCreateResponse>>;
    public pmtProcV1VaultPost(vaultRequest: VaultCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VaultCreateResponse>>;
    public pmtProcV1VaultPost(vaultRequest: VaultCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (vaultRequest === null || vaultRequest === undefined) {
            throw new Error('Required parameter vaultRequest was null or undefined when calling pmtProcV1VaultPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<VaultCreateResponse>(`${this.basePath}/PmtProc/V1/Vault`,
            vaultRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PmtProc_UpdateVault, Update payment information in the Vault
     * Update payment information in the Vault
     * @param TokenId Enter the TokenId to update information from vault
     * @param vaultRequest Enter the payment information to be saved in vault.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pmtProcV1VaultPut(TokenId: string, vaultRequest: VaultCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<VaultCreateResponse>;
    public pmtProcV1VaultPut(TokenId: string, vaultRequest: VaultCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VaultCreateResponse>>;
    public pmtProcV1VaultPut(TokenId: string, vaultRequest: VaultCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VaultCreateResponse>>;
    public pmtProcV1VaultPut(TokenId: string, vaultRequest: VaultCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (TokenId === null || TokenId === undefined) {
            throw new Error('Required parameter TokenId was null or undefined when calling pmtProcV1VaultPut.');
        }
        if (vaultRequest === null || vaultRequest === undefined) {
            throw new Error('Required parameter vaultRequest was null or undefined when calling pmtProcV1VaultPut.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (TokenId !== undefined) {
            queryParameters = queryParameters.set('TokenId', <any>TokenId);
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<VaultCreateResponse>(`${this.basePath}/PmtProc/V1/Vault`,
            vaultRequest,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
